<template id="view-printConditions">
  <div class="container-fluid" id="dashcontainer">
    <nav class="navbar navbar-light bg-light">
      <a class="navbar-brand">Tablero de Control</a>
      <div class="form-inline">
        <ejs-button
          @click.native="filterClick"
          :isPrimary="true"
          iconCss="e-icons icon-filter inline-command"
          cssClass="e-flat e-noback mr-2 mt-2"
          aria:haspopup="true"
          aria-controls="overlay_panel"
          v-if="authorized"
          >Cargar Filtro</ejs-button
        >
        <ejs-button
          @click.native="previewClick"
          :isPrimary="true"
          iconCss="e-icons icon-print inline-command"
          cssClass="e-flat e-noback mr-2 mt-2"
          aria:haspopup="true"
          aria-controls="overlay_panel"
          v-if="canPreview"
          >Pre-Vista</ejs-button
        >
        <ejs-button
          @click.native="printClick"
          :isPrimary="true"
          iconCss="e-icons icon-print inline-command"
          cssClass="e-flat e-noback mr2 mt-2"
          aria:haspopup="true"
          aria-controls="overlay_panel"
          v-if="canPrintManual"
          >Impresion Manual</ejs-button
        >
      </div>
    </nav>
    <Message severity="warn" :closable="false" v-if="messageWarning">
      No estás autorizado para acceder al tablero de control, por favor solicita
      al administrador del sistema configurar y/o verificar los Límites de
      Acceso del usuario!
    </Message>
    <div class="filter-container">
      <!-- <span class="filter-title">Filtrado por:</span> -->
      <Chip class="bg-primary text-white border-50">
        <div class="chip-label">Filtros Aplicados:</div>
      </Chip>
      <Chip
        v-for="filter in filteredFilters"
        :key="filter.key"
        class="chip-container"
      >
        <div class="chip-label">
          <i v-if="filter.value" :class="getIconClass(filter.key)"></i>
          {{ filter.value }}
        </div>
      </Chip>
    </div>
    <div class="row top-row">
      <div class="col-xs-12"></div>
    </div>
    <div class="row" id="gridrow" v-if="!messageWarning">
      <grid-component
        ref="lstGridPrintConditions"
        gridName="PrintConditions"
        :hasRecharge="false"
        :showOnlyView="true"
        :autoFitColumns="true"
        :gridCommands="commands"
        :gridCommandsPosition="'first'"
        @viewClicked="ControlItemClicked"
        @ReloadClicked="GridReloadClicked"
        :showReload="true"
      >
      </grid-component>
      <!-- <grid-component
        ref="lstGridPrintConditions"
        gridName="PrintConditions"
        :hasRecharge="true"
        @reloadData="reloadData"
        @addNew="addPrintConditions"
        @viewData="viewPrintConditions"
        @editData="updatePrintCondition"
        @deleteData="deletePrintCondition"
      >
      </grid-component> -->
    </div>
    <OverlayPanel
      ref="op"
      :style="{ 'max-width': '90%;' }"
      :showCloseIcon="true"
      :dismissable="false"
      :baseZIndex="1002"
      :autoZIndex="false"
    >
      <DashboardFilter
        ref="filter"
        @OnFilterAction="filterClicked"
        :filterData="currentFilter"
        :filterSources="filterSource"
      >
      </DashboardFilter>
    </OverlayPanel>

    <OverlayPanel
      ref="op2"
      :showCloseIcon="true"
      :dismissable="false"
      :baseZIndex="1002"
      :autoZIndex="false"
    >
      <dashboard-preview
        ref="preview"
        @OnPreviewAction="previewClicked"
        :filterSources="filterSource"
      >
      </dashboard-preview>
    </OverlayPanel>

    <OverlayPanel
      ref="opManual"
      style="width: 600px; z-index: 1003"
      :showCloseIcon="true"
      :dismissable="false"
      :baseZIndex="1002"
      :autoZIndex="false"
    >
      <dashboard-manual
        ref="manual"
        @OnPrintAction="manualClicked"
        :filterSources="filterSource"
      >
      </dashboard-manual>
    </OverlayPanel>

    <Sidebar
      :visible.sync="showSidebar"
      :showCloseIcon="true"
      position="right"
      :baseZIndex="1003"
      :autoZIndex="false"
      style="min-width: 80%; z-index: 1003"
    >
      <history-overlay
        ref="historyComponent"
        :currentData="currentControlData"
        :printControl="currentPrintControl"
        @ReloadClicked="historyReloadClicked"
        :showReload="true"
      ></history-overlay>
    </Sidebar>
  </div>
</template>

<script>
/*Imports de VueJS*/
import Vue from "vue";

import { FormActionEnum } from "../../services/enums.js";
// import GridComponent from "../shared/GridComponent.vue";

import GridComponent from "../shared/GridComponentPrimeVue.vue";
import DashboardFilter from "./DashboardFilter.vue";
import DashboardPreview from "./DashboardPrintPreview.vue";
import DashboardManual from "./DashboardPrintManual.vue";
import HistoryOverlay from "./HistoryOverlay.vue";

import { DialogPlugin } from "@syncfusion/ej2-vue-popups";

import PermissionMixin from "../../mixins/PermissionMixin";
import ToastMixin from "../../mixins/ToastMixin";

/*Imports de Syncfusion*/
import { Browser } from "@syncfusion/ej2-base";
import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
//import { ChipListPlugin } from "@syncfusion/ej2-vue-buttons";
import Chip from "primevue/chip";
import { DialogUtility } from "@syncfusion/ej2-popups";
import { TooltipPlugin } from "@syncfusion/ej2-vue-popups";

//Imports de PrimeVue
import OverlayPanel from "primevue/overlaypanel";
import Sidebar from "primevue/sidebar";
import Message from "primevue/message";

Vue.use(ButtonPlugin);
Vue.use(TooltipPlugin);
Vue.use(DialogPlugin);
//Vue.use(ChipListPlugin);

export default Vue.extend({
  name: "PrintConditions",
  mixins: [PermissionMixin, ToastMixin],
  components: {
    GridComponent,
    DashboardFilter,
    OverlayPanel,
    HistoryOverlay,
    Sidebar,
    Message,
    DashboardPreview,
    DashboardManual,
    Chip
  },
  created() {
    this.formAction = FormActionEnum.LIST;
  },
  async mounted() {
    this.currentFilter = {
      companyId: null,
      macroLineId: null,
      lineId: null,
      branchOfficeId: null,
      businessUnitId: null,
      endorsementTypeId: null,
      endorsementSubTypeId: null,
      policyHolderId: null,
      productId: null,
      agentId: null,
      holderId: null,
      validFrom: null,
      validThru: null,
      policyNumber: null,
      printEnabled: false,
      isActive: false,
      filterStartDate: null,
      filterEndDate: null,
      isAgent: null,
      userId: null
    };

    /*
      public DateTime FilterStartDate { get; set; }
      public DateTime FilterEndDate { get; set; }
    */

    var today = new Date();
    this.currentFilter.filterEndDate = new Date();
    this.currentFilter.filterStartDate = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );

    this.currentFilter.filterStartDate.setDate(today.getDate() - 1);
    this.currentFilter.filterEndDate.setDate(today.getDate() + 1);

    //Obtener los datos del usuario.
    var currentUser = localStorage.getItem("user");
    this.currentFilter.userId = currentUser;
    this.authorized = false;

    await this.$store.dispatch("userLimits/getLimit", currentUser);
    var data = this.$store.getters["userLimits/currentLimit"];
    this.messageWarning = false;

    if (!data) {
      console.log("paso");
      this.messageWarning = true;
      this.userLimit = null;
      return;
    } else {
      this.userLimit = JSON.parse(JSON.stringify(data));
    }

    this.authorized = true;

    await this.loadFormData();
  },
  updated() {},

  computed: {
    header() {
      if (this.formAction === FormActionEnum.ADD) {
        return "Nueva Condición";
      }
      if (this.formAction === FormActionEnum.VIEW) {
        return "Consultar Condición";
      }
      if (this.formAction === FormActionEnum.EDIT) {
        return "Modificar Condición";
      }
      if (this.formAction === FormActionEnum.DELETE) {
        return "Deshabilitar Condición";
      }
      return "";
    },
    rowData() {
      return this.$store.getters["printConditions/currentPrintCondition"];
    },
    formData() {
      return JSON.parse(JSON.stringify(this.rowData));
    },
    canPreview() {
      return this.hasPermission("CanPreview") && this.authorized;
    },
    canPrintManual() {
      return this.hasPermission("CanPrintManual") && this.authorized;
    },
    formattedFilters() {
      var instance = this;
      const filters = [];
      const filterMapping = {
        companyId: "Todas las Compañías",
        branchOfficeId: "Todas las Sucursales",
        businessUnitId: "Todas las Unidades Comerciales",
        endorsementSubTypeId: "Todos los Grupos de Endoso",
        endorsementTypeId: "Todos los Tipos de Endoso",
        filterEndDate: null,
        filterStartDate: null,
        holderId: null,
        lineId: "Todos los Ramos",
        macroLineId: "Todos los Macro Ramos",
        policyHolderId: null,
        policyNumber: null,
        agentId: null,
        productId: null,
        validFrom: null,
        validThru: null
      };

      //no usar la lista filtrada, usar los Filtros!!!!
      // const controlList = this.printControlList();
      console.log(this.currentFilter);
      console.log(instance.filterSource);

      for (const key in this.currentFilter) {
        const filterValue = this.currentFilter[key];

        var validateValue = filterValue?.toString() || "";

        // validateValue !== null &&
        // validateValue.length > 0 &&
        if (Object.keys(filterMapping).includes(key)) {
          let value = validateValue;

          let order = 99;

          if (key === "companyId") {
            if (value?.length > 0)
              value = instance.filterSource.companies?.find(
                (x) => x.integerValue == filterValue
              )?.description;
            else value = filterMapping[key];
            order = 3;
          }

          if (key === "macroLineId") {
            if (value?.length > 0)
              value =
                instance.filterSource.macroLines?.find(
                  (x) => x.IdMacroRamo == filterValue
                )?.DescMacroramo || filterMapping[key];
            else value = filterMapping[key];
            order = 4;
          }

          if (key === "lineId") {
            if (value?.length > 0)
              value =
                instance.filterSource.insuranceLines?.find(
                  (x) => x.IdRamo == filterValue
                )?.DescRamo || filterMapping[key];
            else value = filterMapping[key];
            order = 5;
          }

          if (key === "branchOfficeId") {
            if (value?.length > 0)
              value =
                instance.filterSource.branchOffices?.find(
                  (x) => x.CodigoSucursal == filterValue
                )?.DescSucursal || filterMapping[key];
            else value = filterMapping[key];
            order = 6;
          }

          if (key === "businessUnitId") {
            if (value?.length > 0)
              value =
                instance.filterSource.businessUnits?.find(
                  (x) => x.IdUnidadComercial == filterValue
                )?.DescUnidadComercial || filterMapping[key];
            else value = filterMapping[key];
            order = 7;
          }

          if (key === "endorsementTypeId") {
            if (value?.length > 0)
              value =
                instance.filterSource.endorsementTypes?.find(
                  (x) => x.IdGrupoEndoso == filterValue
                )?.DescGrupodeEndoso || filterMapping[key];
            else value = filterMapping[key];
            order = 8;
          }

          if (key === "endorsementSubTypeId") {
            if (value?.length > 0)
              value =
                instance.filterSource.endorsementSubTypes?.find(
                  (x) => x.IdTipoEndoso == filterValue
                )?.DescTipoEndoso || filterMapping[key];
            else value = filterMapping[key];
            order = 9;
          }

          if (
            (key === "filterEndDate" ||
              key === "filterStartDate" ||
              key === "validFrom" ||
              key === "validThru") &&
            value?.length > 0
          ) {
            const date = new Date(filterValue);
            value = date.toLocaleDateString("es-CO");
          }

          if (key === "filterStartDate" && value?.length > 0) {
            value = "Imp.Desde: " + value;
            order = 1;
          }

          if (key === "filterEndDate" && value?.length > 0) {
            value = "Imp.Hasta: " + value;
            order = 2;
          }

          if (key === "agentId" && value?.length > 0) {
            value = "Cod.Agente: " + value;
            order = 10;
          }

          if (key === "holderId" && value?.length > 0) {
            value = "Cod.Tom: " + value;
            order = 11;
          }

          if (key === "policyHolderId" && value?.length > 0) {
            value = "Doc.Tom: " + value;
            order = 12;
          }

          if (key === "policyNumber" && value?.length > 0) {
            value = "Nro.Pol: " + value;
            order = 13;
          }

          if (key === "validFrom" && value?.length > 0) {
            value = "Emi.Desde: " + value;
            order = 14;
          }
          if (key === "validThru" && value?.length > 0) {
            value = "Emi.Hasta: " + value;
            order = 15;
          }

          if (value !== null && value?.toString().length > 0)
            filters.push({ key, value, order });
        }
      }

      // Object.keys(filterMapping).forEach((key) => {
      //   if (!filters.some((filter) => filter.key === key)) {
      //     filters.push({
      //       key,
      //       value: filterMapping[key]
      //     });
      //   }
      // });

      return filters?.sort((x) => x.order);

      /*
      //if (instance.filterSource && filterMapping) return [];

      function getFilterNameById(id, controlList, key, defaultValue) {
        const controlItem = controlList.find((item) => item[key + "Id"] === id);
        return controlItem && controlItem[key]
          ? controlItem[key]
          : defaultValue;
      }

      for (const key in this.currentFilter) {
        const filterValue = this.currentFilter[key];

        if (
          filterValue !== null &&
          filterValue !== "" &&
          Object.keys(filterMapping).includes(key)
        ) {
          let value = filterValue.toString();

          // Obtener el nombre del filtro correspondiente
          if (key === "branchOfficeId") {
            value = getFilterNameById(
              filterValue,
              controlList,
              "branchOffice",
              value
            );
          } else if (key === "businessUnitId") {
            value = getFilterNameById(
              filterValue,
              controlList,
              "businessUnit",
              value
            );
          } else if (key === "endorsementSubTypeId") {
            value = getFilterNameById(
              filterValue,
              controlList,
              "endorsementSubType",
              value
            );
          } else if (key === "endorsementTypeId") {
            value = getFilterNameById(
              filterValue,
              controlList,
              "endorsementType",
              value
            );
          } else if (key === "macroLineId") {
            value = getFilterNameById(
              filterValue,
              controlList,
              "macroLine",
              value
            );
          } else if (key === "lineId") {
            value = getFilterNameById(
              filterValue,
              controlList,
              "insuranceLine",
              value
            );
          } else if (
            key === "filterEndDate" ||
            key === "filterStartDate" ||
            key === "validFrom" ||
            key === "validThru"
          ) {
            const date = new Date(filterValue);
            value = date.toLocaleDateString("es-CO");
          }

          filters.push({
            key,
            value
          });
        }
      }
      Object.keys(filterMapping).forEach((key) => {
        if (!filters.some((filter) => filter.key === key)) {
          filters.push({
            key,
            value: filterMapping[key]
          });
        }
      });
      console.log(this.currentFilter);
*/
    },
    filteredFilters() {
      return this.formattedFilters
        .filter((filter) => filter.value)
        .sort((a, b) => (a.order > b.order ? 1 : -1));
    }
  },
  data() {
    return {
      currentFilter: null,
      filterSource: null,
      dlgShow: false,
      formAction: FormActionEnum.LIST,
      isMobile: Browser.isDevice,
      deleteDialog: {},
      toolTip: "",
      filter: { type: "CheckBox" },
      selectionSettings: { persistSelection: true },
      fields: { text: "name", value: "id" },
      query: "",
      dataList: [],
      macroLines: null,
      lines: null,
      branchOffices: null,
      businessUnits: null,
      endorsementsTypes: null,
      endorsementSubTypes: null,
      currentControlData: [],
      currentPrintControl: null,
      showSidebar: false,
      authorized: false,
      messageWarning: false,
      userLimit: {},
      selectedFilters: []
    };
  },
  provide: {},
  methods: {
    async loadFormData() {
      this.$parent.showLoading();

      this.filterSource = await this.loadFilterSources();

      this.$refs.lstGridPrintConditions.clearDataGrid();

      var MacroRamos = await this.$store.dispatch(
        "printConditions/getTableData",
        {
          schema: "param",
          name: "MacroRamos"
        }
      );
      this.macroLines = JSON.parse(JSON.stringify(MacroRamos.data));

      var Ramos = await this.$store.dispatch("printConditions/getTableData", {
        schema: "param",
        name: "ramos"
      });
      this.lines = JSON.parse(JSON.stringify(Ramos.data));

      var Suc = await this.$store.dispatch("printConditions/getTableData", {
        schema: "param",
        name: "Sucursales"
      });
      this.branchOffices = JSON.parse(JSON.stringify(Suc.data));

      var UnidadesComerciales = await this.$store.dispatch(
        "printConditions/getTableData",
        {
          schema: "param",
          name: "UnidadesComerciales"
        }
      );
      this.businessUnits = JSON.parse(JSON.stringify(UnidadesComerciales.data));

      var GrupoEndoso = await this.$store.dispatch(
        "printConditions/getTableData",
        {
          schema: "param",
          name: "GruposEndosos"
        }
      );
      this.endorsementsTypes = JSON.parse(JSON.stringify(GrupoEndoso.data));

      var TiposEndosos = await this.$store.dispatch(
        "printConditions/getTableData",
        {
          schema: "param",
          name: "TiposEndosos"
        }
      );
      this.endorsementSubTypes = JSON.parse(JSON.stringify(TiposEndosos.data));

      await this.fetchData();
      await this.$store.dispatch("packages/getPackages");
      await this.$store.dispatch("documents/getDocuments");
      await this.$store.dispatch("formats/getFormats");
      await this.$store.dispatch("integrations/getIntegrations");
      this.$parent.hideLoading(500);
    },
    async ControlItemClicked(args) {
      var data = await this.$store.dispatch(
        "dashboard/getControlData",
        args.processId
      );

      this.currentPrintControl = JSON.parse(JSON.stringify(args));
      this.currentControlData = JSON.parse(JSON.stringify(data));
      this.showSidebar = true;

      // setTimeout(() => {
      //   console.log(this.currentControlData);
      //   this.$refs.historyComponent.setCurrentData(this.currentControlData);
      // }, 100);
    },
    async historyReloadClicked() {
      this.$parent.showLoading();
      var processId = this.currentPrintControl.processId;
      var data = await this.$store.dispatch(
        "dashboard/getControlData",
        processId
      );

      this.currentControlData = JSON.parse(JSON.stringify(data));

      this.$refs.historyComponent.refresh(this.currentControlData);

      this.$parent.hideLoading(500);
    },
    sideBarClosed() {
      this.showSidebar = false;
      this.currentControlData = [];
      this.currentPrintControl = null;
    },
    filterClick(args) {
      this.$refs.op.show(args);
      // this.$refs.op.toggle(args);
    },
    previewClick(args) {
      this.$refs.op2.show(args);
    },
    printClick(args) {
      this.$refs.opManual.show(args);
    },
    async filterClicked(args) {
      this.currentFilter = JSON.parse(JSON.stringify(args));
      this.$refs.op.hide();
      await this.reloadData();
    },
    async previewClicked(args) {
      var queued = await this.$store.dispatch(
        "dashboard/sendPrintPreview",
        args
      );
      if (queued) {
        this.showToast(
          "Previsualización en Cola",
          "Se ha Encolado la previsualización para impresión, por favor validar en el tablero de control!",
          2000
        );
      }
      this.$refs.op2.hide();
    },
    async manualClicked(args) {
      var requestmodel = await this.getBackendDataForManualPrintModel(args);

      var endorsementId = await this.$store.dispatch(
        "dashboard/getEndorsementId",
        requestmodel
      );
      if (endorsementId == 0) {
        this.showToast(
          "No encontrado!",
          "No se encuentra el endoso solicitado.",
          4000
        );
        this.$refs.manual.enablePrintButton();
        return;
      } else if (endorsementId > 0) {
        this.$parent.showLoading();
        requestmodel.macroLineId = args.macroLine;
        requestmodel.endorsementId = endorsementId;
        requestmodel.isRegeneration = args.isRegeneration;
        var ok = await this.$store.dispatch(
          "dashboard/queueManualPrint",
          requestmodel
        );

        if (ok) {
          this.$parent.hideLoading(500);
          this.$refs.opManual.show(args);
          this.showToast(
            "En Cola!",
            "Se ha puesto en cola la impresión solicitada.",
            4000
          );
          this.$refs.manual.enablePrintButton();
        } else {
          this.$parent.hideLoading(500);
          this.showToast(
            "Error!",
            "Ha ocurrido un error al encolar la impresión!",
            4000
          );
          this.$refs.manual.enablePrintButton();
        }
      }
      // this.$refs.op2.hide();
    },
    async getBackendDataForManualPrintModel(data) {
      //Traducir codigo de sucursal y ramo
      const model = {
        branchOfficeCode: data.branchOffice,
        companyId: data.company,
        endorsementNumber: data.endorsementNumber,
        policyNumber: data.policyNumber
      };

      var localCode = this.filterSource.insuranceLines.find(
        (el) =>
          el.IdMacroRamo == data.macroLine && el.IdRamo == data.insuranceLine
      );
      model.insuranceLineCode = localCode?.CodigoRamo ?? 0;

      return model;
    },

    async loadFilterSources() {
      var instance = this;

      var sourceItem = {};
      sourceItem.companies = await this.$store.dispatch(
        "minosParameters/getParameterValuesByCode",
        { code: "COMPANY_CODES", returnObject: true }
      );

      var MacroRamos = await this.$store.dispatch(
        "printConditions/getTableData",
        {
          schema: "param",
          name: "MacroRamos"
        }
      );

      var filteredMacroLines = [];
      var mLines = JSON.parse(JSON.stringify(MacroRamos.data));
      mLines = mLines || [];

      mLines.forEach((el) => {
        var found = instance.userLimit.macroLines.find(
          (x) => x.macroLineId == el.IdMacroRamo
        );
        if (found != undefined) {
          filteredMacroLines.push(el);
        }
      });

      sourceItem.macroLines = filteredMacroLines;

      var Ramos = await this.$store.dispatch("printConditions/getTableData", {
        schema: "param",
        name: "Ramos"
      });

      var filteredLines = [];
      var lines = JSON.parse(JSON.stringify(Ramos.data));
      lines = lines || [];

      lines.forEach((el) => {
        var found = instance.userLimit.lines.find(
          (x) => x.macroLineId == el.IdMacroRamo && x.lineId == el.IdRamo
        );
        if (found != undefined) {
          filteredLines.push(el);
        }
      });

      sourceItem.insuranceLines = filteredLines;

      var Suc = await this.$store.dispatch("printConditions/getTableData", {
        schema: "param",
        name: "Sucursales"
      });

      var filteredBranchoffices = [];
      var branches = JSON.parse(JSON.stringify(Suc.data));
      branches = branches || [];

      branches.forEach((el) => {
        var found = instance.userLimit.branchOffices.find(
          (x) => x.branchOfficeId == el.CodigoSucursal
        );
        if (found != undefined) {
          filteredBranchoffices.push(el);
        }
      });

      sourceItem.branchOffices = filteredBranchoffices;

      var Unidades = await this.$store.dispatch(
        "printConditions/getTableData",
        {
          schema: "param",
          name: "UnidadesComerciales"
        }
      );

      var filteredBusinessUnits = [];
      var units = JSON.parse(JSON.stringify(Unidades.data));
      units = units || [];

      units.forEach((el) => {
        var found = instance.userLimit.businessUnits.find(
          (x) =>
            x.branchOfficeId == el.CodigoSucursal &&
            x.businessUnitId == el.IdUnidadComercial
        );
        if (found != undefined) {
          filteredBusinessUnits.push(el);
        }
      });

      sourceItem.businessUnits = filteredBusinessUnits;

      /* Determinar si es agente */
      instance.currentFilter.isAgent = instance.userLimit.isAgent;

      if (instance.currentFilter.isAgent) {
        instance.currentFilter.agentId = instance.userLimit.localCode;
      }

      var GruposEndosos = await this.$store.dispatch(
        "printConditions/getTableData",
        {
          schema: "param",
          name: "GruposEndosos"
        }
      );
      sourceItem.endorsementTypes = GruposEndosos.data;

      var TiposEndosos = await this.$store.dispatch(
        "printConditions/getTableData",
        {
          schema: "param",
          name: "TiposEndosos"
        }
      );
      sourceItem.endorsementSubTypes = TiposEndosos.data;

      return sourceItem;
    },

    printControlList() {
      var dateOptions = { year: "numeric", month: "2-digit", day: "2-digit" };
      var instance = this;
      var list = this.$store.getters["dashboard/controlItems"];
      var newList = [];

      if (list && list.length > 0) {
        newList = list.map(function (x) {
          var item = x;

          item.endorsementType = instance.getEndorsementTypeFromId(
            instance.filterSource.endorsementTypes,
            item.endorsementTypeId
          );

          item.endorsementSubType = instance.getEndorsementSubTypeFromId(
            instance.filterSource.endorsementSubTypes,
            item.endorsementSubTypeId
          );

          if (item.expeditionDate != null) {
            item.expeditionDate = new Date(
              item.expeditionDate
            ).toLocaleDateString("es-CO", dateOptions);
          }

          if (item.dateStart != null) {
            item.dateStart = new Date(item.dateStart).toLocaleString("es-CO");
          }
          if (item.dateEnd != null) {
            item.dateEnd = new Date(item.dateEnd).toLocaleString("es-CO");
          }

          if (item.historyDateStart != null) {
            item.historyDateStart = new Date(
              item.historyDateStart
            ).toLocaleString("es-CO");
          }
          if (item.historyDateEnd != null) {
            item.historyDateEnd = new Date(item.historyDateEnd).toLocaleString(
              "es-CO"
            );
          }

          return item;
        });
      }

      var retList = JSON.parse(JSON.stringify(newList));
      return retList;
    },
    getItemNameFromId(list, id) {
      try {
        var hasItems = list && list.length > 0;
        if (hasItems) {
          var item = list.find((x) => x.id == id);
          if (item != null && item != undefined) {
            return item.name;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    getMacroLineFromId(list, id) {
      try {
        var hasItems = list && list.length > 0;
        if (hasItems) {
          var item = list.find((x) => x.IdMacroRamo == id);
          if (item != null && item != undefined) {
            return item.DescMacroramo;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    getLineFromId(list, id) {
      try {
        var hasItems = list && list.length > 0;
        if (hasItems) {
          var item = list.find((x) => x.IdRamo == id);
          if (item != null && item != undefined) {
            return item.DescRamo;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    getBranchOfficeFromId(list, id) {
      try {
        var hasItems = list && list.length > 0;
        if (hasItems) {
          var item = list.find((x) => x.CodigoSucursal == id);
          if (item != null && item != undefined) {
            return item.DescSucursal;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    getBusinessUnitFromId(list, id) {
      try {
        var hasItems = list && list.length > 0;
        if (hasItems) {
          var item = list.find((x) => x.IdUnidadComercial == id);
          if (item != null && item != undefined) {
            return item.DescUnidadComercial;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    getEndorsementTypeFromId(list, id) {
      try {
        var hasItems = list && list.length > 0;
        if (hasItems) {
          var item = list.find((x) => x.IdGrupoEndoso == id);
          if (item != null && item != undefined) {
            return item.DescGrupodeEndoso;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    getEndorsementSubTypeFromId(list, id) {
      try {
        var hasItems = list && list.length > 0;
        if (hasItems) {
          var item = list.find((x) => x.IdTipoEndoso == id);
          if (item != null && item != undefined) {
            return item.DescTipoEndoso;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    async reloadData() {
      //this.$refs.lstGridPrintConditions.clearDataGrid();
      this.$parent.showLoading();
      await this.fetchData();
      this.$parent.hideLoading(500);
    },
    async fetchData() {
      //this.$refs.lstGridFormatos.clearDataGrid();

      await this.$store.dispatch(
        "dashboard/getControlItems",
        this.currentFilter
      );
      this.dataList = this.printControlList();

      //this.macroLinesList();
      this.$refs.lstGridPrintConditions.setGridData(
        this.dataList,
        this.columnsList()
      );
    },
    columnsList() {
      let arrayColumns = [
        { field: "processId", header: "Id. Proceso" },
        { field: "endorsementId", header: "Id. Endoso" },
        { field: "branchOfficeId", header: "Id Sucursal", hidden: true },
        { field: "branchOffice", header: "Sucursal" },
        { field: "macroLineId", header: "Id Macro Ramo", hidden: true },
        { field: "macroLine", header: "Macro Ramo" },
        { field: "insuranceLineId", header: "Ramo", hidden: true },
        { field: "insuranceLine", header: "Ramo" },
        { field: "policyNumber", header: "Póliza" },
        { field: "endorsementNumber", header: "Endoso" },
        { field: "endorsementType", header: "Grupo Endoso" },
        { field: "endorsementSubType", header: "Tipo Endoso" },
        { field: "policyHolderId", header: "Doc. Tomador" },
        { field: "expeditionDate", header: "Fecha Emisión" },
        {
          field: "businessUnitId",
          header: "Id. Unidad Comercial.",
          hidden: true
        },
        {
          field: "businessUnit",
          header: "Unidad Comercial."
        },

        { field: "controlStateId", header: "Id Estado", hidden: true },
        { field: "controlState", header: "Estado" },
        { field: "controlStateMessage", header: "Mensaje Estado" },
        { field: "dateStart", header: "Inicio Proceso" },
        { field: "dateEnd", header: "Fin Proceso" },

        { field: "historyDateStart", header: "Inicio Ult. Proceso" },
        { field: "historyDateEnd", header: "Fin Ult. Proceso" },
        { field: "historyStateId", header: "Id Ult. Proceso", hidden: true },
        { field: "historyState", header: "Estado Ult. Proceso" },
        { field: "historyStateMessage", header: "Mensaje Ult. Proceso" },
        {
          field: "isAutomatic",
          dataType: "boolean",
          header: "Imp. Automática"
        },
        {
          field: "isManual",
          dataType: "boolean",
          header: "Imp. Manual"
        },
        {
          field: "isReprint",
          dataType: "boolean",
          header: "Re-Impresion"
        },
        {
          field: "isReprocess",
          dataType: "boolean",
          header: "Re-Proceso"
        },
        {
          field: "isPreview",
          dataType: "boolean",
          header: "Pre-Vista"
        }
      ];

      return arrayColumns;
    },
    async addPrintConditions() {
      // this.dlgShow = !this.dlgShow;
      // var newPrintCondition = {
      //   isNew: true,
      //   conditionId: 0,
      //   companyId: null,
      //   macroLineId: null,
      //   lineId: null,
      //   branchOfficeId: null,
      //   businessUnitId: null,
      //   endorsementTypeId: null,
      //   endorsementSubTypeId: null,
      //   productId: 0,
      //   agentId: 0,
      //   holderId: 0,
      //   validFrom: "",
      //   validThru: "",
      //   policyNumber: 0,
      //   printEnabled: false,
      //   isActive: false
      // };

      this.formAction = FormActionEnum.ADD;
      //this.showForm(newPrintCondition);
      await this.$store.dispatch("printConditions/initPrintCondition");
      var data = this.$store.getters["printConditions/currentPrintCondition"];
      this.showForm(data);
    },
    viewPrintConditions(rowData) {
      this.formAction = FormActionEnum.VIEW;
      this.showForm(rowData);
    },
    updatePrintCondition(rowData) {
      this.formAction = FormActionEnum.EDIT;
      this.showForm(rowData);
    },
    GridReloadClicked() {
      this.reloadData();
    },
    getAlertDialog(title, content) {
      let dialog = DialogUtility.alert({
        title: title,
        zindex: 1010,
        content: content,
        showCloseIcon: true,
        closeOnEscape: true,
        animationSettings: { effect: "Zoom" }
      });
      return dialog;
    },
    showForm(data) {
      try {
        let hasData = !!data;
        if (hasData) {
          this.$store.dispatch("printConditions/setPrintCondition", data);
        }
      } catch (error) {
        console.log(error);
      }

      this.$refs.printCondForm.setFormData(this.formData, this.formAction);
      this.$refs.printCondForm.loadComponent();
      this.dlgShow = true;
    },
    // onDialogClose() {
    //   this.dlgShow = false;
    //   console.log("close");
    // },
    // onDialogOpen() {
    //   this.dlgShow = true;
    //   console.log("open");
    // },

    closeForm() {
      this.$refs.printCondForm.unloadComponent();
    },
    hideForm() {
      this.dlgShow = false;
    },
    getIconClass(key) {
      // Asigna el icono correspondiente según el filtro
      switch (key) {
        case "companyId":
          return "pi pi-building";
        case "macroLineId":
          return "pi pi-sitemap";
        case "lineId":
          return "pi pi-chart-line";
        case "branchOfficeId":
          return "pi pi-building";
        case "businessUnitId":
          return "pi pi-sort-numeric-down";
        case "endorsementTypeId":
          return "pi pi-sort-alpha-down";
        case "endorsementSubTypeId":
          return "pi pi-sort-alpha-up";
        case "policyHolderId":
          return "pi pi-key";
        case "agentId":
          return "pi pi-user";
        case "holderId":
          return "pi pi-id-card";
        case "validFrom":
          return "pi pi-sort-amount-up";
        case "validThru":
          return "pi pi-sort-amount-down";
        case "policyNumber":
          return "pi pi-file";
        case "filterStartDate":
          return "pi pi-calendar-minus";
        case "filterEndDate":
          return "pi pi-calendar-plus";
        default:
          return "";
      }
    }
  }
});
</script>
<style>
@import url(../../../node_modules/bootstrap/dist/css/bootstrap.min.css);
@import url(../../../node_modules/@syncfusion/ej2-base/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-notifications/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-buttons/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-inputs/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-popups/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-navigations/styles/fabric.css);
@import url(../../../node_modules/vue-loading-overlay/dist/vue-loading.css);
@import url(../form-icons.css);

.e-alert-dialog.e-dialog.e-popup,
.e-confirm-dialog.e-dialog.e-popup {
  margin: auto !important;
}

.p-overlaypanel {
  max-width: 90% !important;
  /* offset-x | offset-y | blur-radius | color */
  box-shadow: 5px 5px 5px 3px #ccc;
  z-index: 1003 !important;
}

.content-wrapper {
  width: 100%;
  margin: 15px auto;
  min-width: 185px;
}
@media only screen and (max-width: 480px) {
  .content-wrapper {
    width: 92%;
  }
}
.e-add-icon {
  background-repeat: no-repeat;
}
#conditions-form {
  width: 100%;
  height: 100%;
}

#dialogCondiciones,
#cardCondiciones {
  position: fixed;
  top: 60px;
  left: 0;
  width: 100% !important;
  height: 100% !important;
}

.filter-container {
  display: flex;
  align-items: center;
  font-size: 10px;
  flex-wrap: wrap;
  line-height: 1.5rem;
}

.filter-title {
  font-weight: bold;
  font-size: 15px;
  line-height: 1rem;
  margin-right: 1px;
  margin-bottom: 1px;
  /* margin-right: 10px;
  margin-left: 18px;
  margin-top: 7px; */
}

.filter-buttons {
  border: none;
}

.filter-button {
  border-radius: 20%;
  background-color: #e0e0e0;
  color: black;
  border: none;
  outline: none;
}

.p-component .chip-label {
  font-size: 12px !important;
}

.chip-container {
  margin-right: 1px;
  margin-bottom: 1px;
}

.last-lineId-chip {
  margin-right: 0;
}
</style>
